export const TRIPTICKETIMAGETYPE = 'ticket_image';
export const TRIPSIGNATUREIMAGETYPE = 'signature_image';
